import { render, staticRenderFns } from "./InteractiveAvatar.vue?vue&type=template&id=3639182a&scoped=true"
import script from "./InteractiveAvatar.vue?vue&type=script&lang=js"
export * from "./InteractiveAvatar.vue?vue&type=script&lang=js"
import style0 from "./InteractiveAvatar.vue?vue&type=style&index=0&id=3639182a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3639182a",
  null
  
)

export default component.exports